<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:0px;">Gary M. Williams was born and raised in Staten Island, New York. He was a teacher and principal with the New York City Department of Education for thirty-five years. He is currently retired and resides in Manhattan and is now assuming a full-time career in writing.</p><br/>
<p style="text-indent:0px;">He was inspired to write a historical fictional novel spanning the twentieth century after visits to Newport, Rhode Island, and Europe. After two years of research and eight years of writing, <em>Gone but Not Forgotten</em>, the first of a trilogy, along with the second and third books, reached their completion.</p><br/>
<p style="text-indent:0px;">In addition to writing, Mr. Williams holds a strong avocation for the arts. His hobbies include theater, reading, and world travel. He is currently working on his next novel and anticipates adding it to his literary repertoire.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?0e47ea87